import { Navigate, Outlet, useLocation } from 'react-router-dom';
// hooks
import { useAuth } from 'hooks';

const RestrictedRoutesOutlet = ({ redirectTo }) => {
  const location = useLocation();
  const { isLoggedIn } = useAuth();
  const from = location.state?.from?.pathname;

  return isLoggedIn ? (
    <Navigate to={from || redirectTo} state={{ from: location }} />
  ) : (
    <Outlet />
  );
};

export default RestrictedRoutesOutlet;
